var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(function () {
    angular.module('QMC.Medikamente', []).config(routes);
    // Medikamente
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('medicament', {
            url: '/medicament',
            templateUrl: qmcBase + '/Medikamente',
            controller: 'MedikamenteListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Medicament');
                    }]
            }
        }).state('medicamentList', {
            url: '/medicament/List',
            templateUrl: qmcBase + '/Medikamente/List',
            controller: 'MedikamenteListController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Medicament list');
                    }]
            }
        }).state('medicamentDetail', {
            url: '/medicament/:id',
            templateUrl: qmcBase + '/Medikamente/Detail',
            controller: 'MedikamenteDetailController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Medicament detail');
                    }]
            }
        }).state('medicamentPlannedDistribution', {
            url: '/medicament/plannedDistribution',
            templateUrl: qmcBase + '/Medikamente/PlannedDistribution',
            controller: 'MedikamenteDistributionController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Medicament distributed');
                    }]
            }
        }).state('medicamentDemandDistribution', {
            url: '/medicament/demandDistribution',
            templateUrl: qmcBase + '/Medikamente/DemandDistribution',
            controller: 'MedikamenteDistributionController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Medicament distributed');
                    }]
            }
        })
            .state('medicamentDistributionReference', {
            url: '/medicament/distribution/:reference',
            templateUrl: qmcBase + '/Medikamente/Distribution',
            controller: 'MedikamenteDistributionController',
            controllerAs: 'vm',
            resolve: {
                data: [function () {
                        console.log('Current State: Medicament distributed Reference');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Medikamente;
    (function (Medikamente) {
        var HttpProvider = /** @class */ (function () {
            function HttpProvider() {
            }
            HttpProvider.configureHttpProvider = function ($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            };
            return HttpProvider;
        }());
        Medikamente.HttpProvider = HttpProvider;
    })(Medikamente = QMC.Medikamente || (QMC.Medikamente = {}));
})(QMC || (QMC = {}));
(function () {
    angular.module('QMC.Medikamente')
        .config(['$httpProvider', QMC.Medikamente.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Medikamente;
    (function (Medikamente) {
        var MedikamenteService = /** @class */ (function (_super) {
            __extends(MedikamenteService, _super);
            function MedikamenteService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.modulePath = '/Medicament';
                return _this;
            }
            //////////////////////////// Medicament //////////////////////////
            MedikamenteService.prototype.getMedicamentWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/WvModel', {}, function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.getMedicament = function (id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/' + id, {}, function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.getMedicamentList = function (page, pageSize, listSearch, searchProperties) {
                if (listSearch === void 0) { listSearch = ''; }
                if (searchProperties === void 0) { searchProperties = []; }
                return _super.prototype.getItem.call(this, this.modulePath + '', { page: page, pageSize: pageSize, listSearch: listSearch, searchProperties: searchProperties }, function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.postMedicament = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '', data).then(function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.putMedicament = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.deleteMedicament = function (id) {
                return _super.prototype.delete.call(this, this.modulePath + '/' + id).then(function (data) {
                    return data;
                });
            };
            //////////////////////// Medicament Package //////////////////////
            MedikamenteService.prototype.getMedicamentPackageWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/Package/WvModel', {}, function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.postMedicamentPackage = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Package', data).then(function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.putMedicamentPackage = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/Package/' + id, data).then(function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.getMedicamentPackage = function (id, parentId) {
                return _super.prototype.getItem.call(this, this.modulePath + '/Package/' + id + "/" + parentId, {}, function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.deleteMedicamentPackage = function (id, parentId) {
                return _super.prototype.delete.call(this, this.modulePath + '/Package/' + id + '/' + parentId).then(function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.getMedicamentPackageList = function (id) {
                return _super.prototype.get.call(this, this.modulePath + '/Package/' + id, {}, function (data) {
                    return data;
                });
            };
            /////////////////////////// Distribution /////////////////////////
            MedikamenteService.prototype.getMedicationLists = function (dateFrom, dateTo, onlyUncompleted, onlyUndocumented) {
                return _super.prototype.getItem.call(this, this.modulePath + '/Medication', { dateFrom: dateFrom, dateTo: dateTo, onlyUncompleted: onlyUncompleted, onlyUndocumented: onlyUndocumented }, function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.getDemandMedicationLists = function (dateFrom, dateTo, onlyUncompleted, onlyUndocumented) {
                return _super.prototype.get.call(this, this.modulePath + '/Medication/Demand', { dateFrom: dateFrom, dateTo: dateTo, onlyUncompleted: onlyUncompleted, onlyUndocumented: onlyUndocumented }, function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.getPlannedMedicationLists = function (dateFrom, dateTo, onlyUncompleted, onlyUndocumented) {
                return _super.prototype.get.call(this, this.modulePath + '/Medication/Planned', {
                    dateFrom: dateFrom, dateTo: dateTo, onlyUncompleted: onlyUncompleted, onlyUndocumented: onlyUndocumented
                }, function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.getDistributionsForMedication = function (dateFrom, dateTo, medicationId) {
                return _super.prototype.get.call(this, this.modulePath + '/Medication/DistributionsForMedication', { dateFrom: dateFrom, dateTo: dateTo, medicationId: medicationId }, function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.getMedicationWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/Medication/WvModel', {}, function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.postMedication = function (reference, data) {
                return _super.prototype.post.call(this, this.modulePath + '/Medication/' + reference, data).then(function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.postMedications = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Medication/', data).then(function (data) {
                    return data;
                });
            };
            MedikamenteService.prototype.postValidation = function (data) {
                return _super.prototype.post.call(this, this.modulePath + '/Medication/WarningsAndErrors', data).then(function (data) {
                    return data;
                });
            };
            MedikamenteService = __decorate([
                QMC.Service('QMC.Medikamente', 'MedikamenteService'),
                QMC.Inject('$http', '$q')
            ], MedikamenteService);
            return MedikamenteService;
        }(QMC.Common.BaseService));
        Medikamente.MedikamenteService = MedikamenteService;
    })(Medikamente = QMC.Medikamente || (QMC.Medikamente = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Medikamente;
    (function (Medikamente) {
        var MedikamenteListController = /** @class */ (function () {
            function MedikamenteListController($location, medicamentService, $qui, $stateParams, $state, $scope, lng, permissionService, userService) {
                var _this = this;
                this.$location = $location;
                this.medicamentService = medicamentService;
                this.$qui = $qui;
                this.$state = $state;
                this.$scope = $scope;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                //////////////////////////// Variables ///////////////////////////
                /************************* GUI Variables ************************/
                this.ui = new Medikamente.UserInterface();
                this.allowTableExport = false;
                this.page = 0;
                this.filter = '';
                this.modify = true;
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    $(".help-block").parent("div").attr("style", "");
                });
                if (document.getElementById("permissions").getAttribute("medicament").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module medicament");
                    this.forbidden = true;
                    return;
                }
                this.cards = QMC.Common.Constants.IS_MOBILE;
                this.$qui.getTableAutoload(this.userService).then(function (ltd) {
                    _this.shouldLoadTableData = ltd;
                    if (_this.shouldLoadTableData) {
                        _this.$scope.$watch('vm.filter', function (newValue, oldValue) {
                            var _this = this;
                            if (newValue === oldValue)
                                return;
                            var lastValue = this.filter;
                            setTimeout(function () {
                                if (_this.filter === lastValue) {
                                    _this.getData();
                                }
                            }, 500);
                        }.bind(_this, _this));
                    }
                });
                this.getWvs();
                this.init();
                this.permissionLoad = true;
                permissionService.getPermissionsByObjectType(810000).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.view = data[0].view;
                    _this.allowTableExport = data[0].print;
                    _this.permissionLoad = false;
                });
            }
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            MedikamenteListController.prototype.init = function () {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    title: null,
                    presentationId: null,
                    producerId: null,
                    categoryId: null,
                    isPrescriptionNeeded: false,
                    isPharmacyOnly: false,
                    isRestricted: false,
                    isAnesthetic: false,
                    activeComponent: null,
                    comment: null,
                    mediNr: null
                };
            };
            MedikamenteListController.prototype.setPage = function (page) {
                this.page = page;
            };
            MedikamenteListController.prototype.getData = function () {
                if (this.pageWatcher)
                    this.pageWatcher();
                this.getMedicaments();
                this.page = 0;
            };
            ////////////////////////// SERVICECALLS //////////////////////////
            MedikamenteListController.prototype.getMedicaments = function () {
                var _this = this;
                this.medicamentLoad = true;
                if (this.pageWatcher)
                    this.pageWatcher();
                this.medicamentService.getMedicamentList(this.page, QMC.Common.Constants.DEFAULT_PAGINATION_SIZE, this.filter, this.ui.getDisplayedPropertiesFromSchema(this.ui.medicamentTable)).then(function (data) {
                    _this.medicaments = data.items;
                    _this.paginationInfo = data.paginationInfo;
                    _this.ui.medicamentTable.data = data.items;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.medicamentLoad = false;
                    _this.pageWatcher = _this.$scope.$watch('vm.page', function (newValue, oldValue) {
                        if (newValue !== oldValue)
                            _this.getMedicaments();
                    });
                });
            };
            MedikamenteListController.prototype.addMedicament = function () {
                var _this = this;
                if (this.form.title !== null && this.form.title !== undefined && this.form && this.form.presentationId !== null && this.form.presentationId !== undefined) {
                    this.medicamentService.postMedicament(this.form).then(function () {
                        _this.ui.notify(_this.ui.successNote);
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                        _this.formState = "new";
                        _this.getData();
                    });
                }
            };
            MedikamenteListController.prototype.getPresentationWvList = function () {
                return this.ui.select(this.wvLists.presentationWvList, { value: "objectId", text: "name" });
            };
            MedikamenteListController.prototype.getCategoryList = function () {
                return this.ui.select(this.wvLists.categoryWvList, { value: "objectId", text: "name" });
            };
            MedikamenteListController.prototype.getProducerWvList = function () {
                return this.ui.select(this.wvLists.producerWvList, { value: "objectId", text: "name" });
            };
            MedikamenteListController.prototype.getWvs = function () {
                var _this = this;
                this.medicamentLoad = true;
                this.medicamentService.getMedicamentWv().then(function (data) {
                    _this.wvLists = data;
                    _this.$qui.functionWaiter("ui.createForm", _this);
                    _this.medicamentLoad = false;
                });
            };
            MedikamenteListController = __decorate([
                QMC.Controller('QMC.Medikamente', 'MedikamenteListController'),
                QMC.Inject('$location', 'MedikamenteService', '$qui', '$stateParams', '$state', '$scope', 'QmcLanguageService', 'QmcPermissionService', 'UserService')
            ], MedikamenteListController);
            return MedikamenteListController;
        }());
    })(Medikamente = QMC.Medikamente || (QMC.Medikamente = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Medikamente;
    (function (Medikamente) {
        var MedikamenteDetailController = /** @class */ (function () {
            /**
             * Creates an instance of MedikamenteDetailController.
             * @param {MedikamenteService} medicamentService
             * @param {any} $qui
             * @param {any} $stateParams
             * @param {any} $state
             * @param {any} $scope
             * @param {Common.QmcLanguageService} lng
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf MedikamenteDetailController
             */
            function MedikamenteDetailController($location, medicamentService, $qui, $stateParams, $state, $scope, lng, permissionService) {
                var _this = this;
                this.$location = $location;
                this.medicamentService = medicamentService;
                this.$qui = $qui;
                this.$state = $state;
                this.$scope = $scope;
                this.lng = lng;
                this.permissionService = permissionService;
                //////////////////////////// Variables ///////////////////////////
                /************************* GUI Variables ************************/
                this.ui = new Medikamente.UserInterface();
                $qui.init($qui.getSectionColor("/medicament"), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                if (document.getElementById("permissions").getAttribute("medicament").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module medicament");
                    this.forbidden = true;
                    return;
                }
                this.medicamentId = $stateParams.id;
                this.init();
                this.initPackageForm();
                this.getMedicament($stateParams.id);
                this.getWvs();
                $scope.$on('$locationChangeStart', function (event) {
                    if ($scope.vm.medicationForm.$dirty) {
                        // show warning, if answer negative stay on this side
                        if (!confirm(_this.lng.translate(20000039, 'Wenn Sie diese Seite verlassen gehen alle Änderungen verloren. Fortfahren?'))) {
                            event.preventDefault();
                        }
                    }
                });
                this.lang = lng;
                this.promptOptions = {
                    title: "Medikament",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                this.permissionLoad = true;
                permissionService.getPermissionsByObjectTypes([810000, 810003]).then(function (data) {
                    _this.delete = data[0].delete && data[0].moduleAccess;
                    _this.new = data[0].new && data[0].moduleAccess;
                    _this.modify = data[0].modify && data[0].moduleAccess;
                    _this.view = data[0].view && data[0].moduleAccess;
                    _this.pdelete = data[1].delete && data[1].moduleAccess;
                    _this.pnew = data[1].new && data[1].moduleAccess;
                    _this.pmodify = data[1].modify && data[1].moduleAccess;
                    _this.pview = data[1].view && data[1].moduleAccess;
                    _this.permissionLoad = false;
                    _this.getMedicamentPackages(_this.medicamentId);
                });
            }
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            /**
             * init mediactionform
             *
             * @private
             *
             * @memberOf MedikamenteDetailController
             */
            MedikamenteDetailController.prototype.init = function () {
                this.medicationForm = {
                    id: null,
                    objectId: null,
                    title: null,
                    application: null,
                    sideEffect: null,
                    contraindication: null,
                    interaction: null,
                    presentationId: null,
                    producerId: null,
                    categoryId: null,
                    isPrescriptionNeeded: false,
                    isPharmacyOnly: false,
                    isRestricted: false,
                    isAnesthetic: false,
                    activeComponent: null,
                    comment: null,
                    restriction: null,
                    mediNr: null,
                    producer: null,
                    packageTypes: []
                };
                this.filter = {
                    'searchText': ""
                };
            };
            /**
             * init Packageform
             *
             * @private
             *
             * @memberOf MedikamenteDetailController
             */
            MedikamenteDetailController.prototype.initPackageForm = function () {
                this.formState = "new";
                this.packageForm = {
                    id: null,
                    objectId: null,
                    parentId: this.medicamentId,
                    dateFrom: new Date(),
                    dateTo: null,
                    packageAmount: 0,
                    packageUnitId: null,
                    standardSizeId: null,
                    pzn: null,
                    ean: null,
                    activeComponentAmount: null,
                    activeComponentUnitId: null,
                    comment: null
                };
            };
            /**
             * check if param is correct guid
             *
             * @private
             * @param {Guid} thing
             * @returns {boolean}
             *
             * @memberOf MedikamenteDetailController
             */
            MedikamenteDetailController.prototype.isSetGuid = function (thing) {
                if (thing !== null && thing !== undefined && thing !== QMC.Common.Constants.GUID_EMPTY)
                    return true;
                else
                    return false;
            };
            ////////////////////////// SERVICECALLS //////////////////////////
            /**
             * get Medication from API
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf MedikamenteDetailController
             */
            MedikamenteDetailController.prototype.getMedicament = function (id) {
                var _this = this;
                this.medicamentLoad = true;
                this.medicamentService.getMedicament(id).then(function (data) {
                    _this.medicationForm = angular.copy(data);
                    _this.storedData = angular.copy(data);
                    _this.displayTitle = data.title;
                    _this.medicamentLoad = false;
                });
            };
            /**
             * get all Packages for Medication
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf MedikamenteDetailController
             */
            MedikamenteDetailController.prototype.getMedicamentPackages = function (id) {
                var _this = this;
                this.packageLoad = true;
                this.medicamentService.getMedicamentPackageList(id).then(function (data) {
                    _this.medicationForm = angular.copy(_this.storedData);
                    _this.ui.mediPackagesTable.data = data;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    _this.packageLoad = false;
                });
            };
            /**
             * put modified mediaction to API
             *
             * @private
             *
             * @memberOf MedikamenteDetailController
             */
            MedikamenteDetailController.prototype.putMedicament = function () {
                var _this = this;
                this.medicamentService.putMedicament(this.medicationForm.objectId, this.medicationForm).then(function (data) {
                    _this.$qui.notify(_this.$qui.successNote, _this.lng.translate(20000291, 'Der Eintrag wurde gespeichert.'));
                    _this.$state.go('medicamentList');
                });
            };
            /**
             * delete medioaction
             *
             * @private
             *
             * @memberOf MedikamenteDetailController
             */
            MedikamenteDetailController.prototype.deleteMedicament = function () {
                var _this = this;
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.medicamentService.deleteMedicament(_this.medicationForm.objectId).then(function () {
                            _this.$qui.notify(_this.$qui.deleteNote);
                            _this.$state.go('medicamentList');
                        });
                });
            };
            /**
             * get PackageTypeList from API
             *
             * @private
             * @returns {ng.IPromise<Common.ISelectListItem[]>}
             *
             * @memberOf MedikamenteDetailController
             */
            MedikamenteDetailController.prototype.getPackageTypeList = function () {
                var _this = this;
                return this.medicamentService.getMedicamentPackageWv().then(function (data) {
                    return _this.ui.select(data.packageUnitWvList, {
                        value: 'objectId',
                        text: 'name'
                    });
                });
            };
            /**
             * get StandardSizeWvList from API
             *
             * @private
             * @returns {ng.IPromise<Common.ISelectListItem[]>}
             *
             * @memberOf MedikamenteDetailController
             */
            MedikamenteDetailController.prototype.getStandardSizeWvList = function () {
                var _this = this;
                return this.medicamentService.getMedicamentPackageWv().then(function (data) {
                    return _this.ui.select(data.standardSizeWvList, {
                        value: "objectId",
                        text: "name"
                    });
                });
            };
            /**
             * get ActiveComponentUnitWvList from API
             *
             * @private
             * @returns {ng.IPromise<Common.ISelectListItem[]>}
             *
             * @memberOf MedikamenteDetailController
             */
            MedikamenteDetailController.prototype.getActiveComponentUnitWvList = function () {
                var _this = this;
                return this.medicamentService.getMedicamentPackageWv().then(function (data) {
                    return _this.ui.select(data.activeComponentUnitWvList, {
                        value: 'objectId',
                        text: 'name'
                    });
                });
            };
            /**
             * get all WV lists
             *
             * @private
             *
             * @memberOf MedikamenteDetailController
             */
            MedikamenteDetailController.prototype.getWvs = function () {
                var _this = this;
                this.medicamentService.getMedicamentWv().then(function (data) {
                    _this.wvLists = data;
                    _this.presentationList = _this.$qui.selectAutoMap(data.presentationWvList, 'objectId', 'name');
                    _this.categoryMap = _this.$qui.selectAutoMap(data.categoryWvList, 'objectId', 'name');
                    _this.producerMap = _this.$qui.selectAutoMap(data.producerWvList, 'objectId', 'name');
                    _this.$qui.functionWaiter("ui.createForm", _this);
                });
            };
            ////////////////////////// Medi Package //////////////////////////
            /**
             * get Medication Package from API for modification
             *
             * @private
             * @param {IMedicamentPackage} data
             *
             * @memberOf MedikamenteDetailController
             */
            MedikamenteDetailController.prototype.editPackage = function (data) {
                var _this = this;
                this.medicamentService.getMedicamentPackage(data.objectId, this.medicamentId).then(function (data) {
                    _this.formState = "edit";
                    _this.packageForm = angular.copy(data);
                    _this.packageForm.dateFrom = _this.$qui.createDateFromString(data.dateFrom);
                    if (data.dateTo !== null)
                        _this.packageForm.dateTo = moment(data.dateTo).toDate();
                });
            };
            /**
             * Post new Medication Package to API
             *
             * @private
             * @param {IMedicamentPackage} form
             *
             * @memberOf MedikamenteDetailController
             */
            MedikamenteDetailController.prototype.postMedicamentPackage = function (form) {
                var _this = this;
                if (this.isSetGuid(form.parentId) && this.isSetGuid(form.packageUnitId)) {
                    this.medicamentService.postMedicamentPackage(this.packageForm).then(function (data) {
                        _this.ui.notify(_this.ui.successNote);
                        _this.getMedicamentPackages(_this.medicamentId);
                        _this.formState = "new";
                    });
                }
            };
            /**
             * Put modified Medication Package to API
             *
             * @private
             * @param {IMedicamentPackage} form
             *
             * @memberOf MedikamenteDetailController
             */
            MedikamenteDetailController.prototype.putMedicamentPackage = function (form) {
                var _this = this;
                form.parentId = this.medicamentId;
                this.medicamentService.putMedicamentPackage(form.objectId, form).then(function (data) {
                    _this.ui.notify(_this.ui.successNote);
                    _this.getMedicamentPackages(_this.medicamentId);
                    _this.formState = "new";
                });
            };
            /**
             * Deleting Medicament Package
             *
             * @private
             * @param {IMedicamentPackage} data
             *
             * @memberOf MedikamenteDetailController
             */
            MedikamenteDetailController.prototype.deleteMedicamentPackage = function (datas) {
                var _this = this;
                $('#medicamentPackageModal').modal('toggle');
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.medicamentService.deleteMedicamentPackage(datas.objectId, _this.medicamentId).then(function () {
                            _this.ui.notify(_this.ui.deleteNote);
                            _this.formState = "new";
                            _this.getMedicamentPackages(_this.medicamentId);
                        });
                });
            };
            MedikamenteDetailController = __decorate([
                QMC.Controller('QMC.Medikamente', 'MedikamenteDetailController'),
                QMC.Inject('$location', 'MedikamenteService', '$qui', '$stateParams', '$state', '$scope', 'QmcLanguageService', 'QmcPermissionService')
            ], MedikamenteDetailController);
            return MedikamenteDetailController;
        }());
    })(Medikamente = QMC.Medikamente || (QMC.Medikamente = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Medikamente;
    (function (Medikamente) {
        var MedikamenteDistributionController = /** @class */ (function () {
            function MedikamenteDistributionController($location, medicamentService, $qui, $stateParams, $state, $scope, lng, clientService, permissionService, userService) {
                var _this = this;
                this.$location = $location;
                this.medicamentService = medicamentService;
                this.$qui = $qui;
                this.$state = $state;
                this.$scope = $scope;
                this.lng = lng;
                this.clientService = clientService;
                this.permissionService = permissionService;
                this.userService = userService;
                //////////////////////////// Variables ///////////////////////////
                /************************* GUI Variables ************************/
                this.ui = new Medikamente.UserInterface();
                this.allowTableExport = false;
                this.loadingPlanned = false;
                this.loadingDemand = false;
                this.cards = false;
                this.isMobile = QMC.Common.Constants.IS_MOBILE;
                this.filterStorageKey = 'mediDistributionFilter_';
                this.isDemand = false;
                this.loadValidation = false;
                this.multiValidationWatcher = [];
                this.currentTimepoints = [];
                this.multiEnabled = false;
                // new multiselection
                this.selectedLines = [];
                this.recentlyDistributedPannedMedications = [];
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    setTimeout(function () {
                        _this.events();
                    }, 500);
                });
                this.isDemand = this.$state.current.name === "medicamentDemandDistribution";
                this.filterStorageKey += this.$state.current.name;
                if (document.getElementById("permissions").getAttribute("medicamentDistribution").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module medicamentDistribution");
                    this.forbidden = true;
                    return;
                }
                this.cards = false;
                if (QMC.Common.Constants.IS_MOBILE)
                    this.cards = true;
                if (!this.isDemand)
                    this.userService.getUserSettings(["MEDAUSGABE.PA.ALLOWMULTIDOCUMENTATION"], false).then(function (data) {
                        _this.multiEnabled = data[0].value.toLowerCase() === 'true';
                    });
                this.permissionLoad = true;
                permissionService.getPermissionsByObjectType(800003).then(function (data) {
                    _this.delete = data[0].delete && data[0].moduleAccess;
                    _this.new = data[0].new && data[0].moduleAccess;
                    _this.modify = data[0].modify && data[0].moduleAccess;
                    _this.view = data[0].view && data[0].moduleAccess;
                    _this.allowTableExport = data[0].print;
                    _this.init();
                    //Get medications is called here, so we can be sure if the user has the permission to see/get the data.
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        if (_this.shouldLoadTableData) {
                            _this.getData();
                        }
                    });
                    _this.permissionLoad = false;
                });
                this.$scope.$on('$destroy', function () { if (_this.refreshTimer)
                    clearTimeout(_this.refreshTimer); });
            }
            MedikamenteDistributionController.prototype.getData = function () {
                var _this = this;
                clearTimeout(this.refreshTimer);
                if (!this.loadingPlanned || !this.loadingDemand)
                    this.getMedications();
                // refresh List every 60secs
                if (!this.isDemand)
                    this.refreshTimer = setTimeout(function () { _this.getData(); }, 60000);
            };
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            MedikamenteDistributionController.prototype.init = function () {
                this.initForm();
                this.filterPeriodValue = '2';
                this.onlyUndocumented = false;
                this.onlyUncompleted = false;
                var mediFilterSettings = localStorage.getItem(this.filterStorageKey);
                if (mediFilterSettings) {
                    var filterObj = JSON.parse(mediFilterSettings);
                    this.filterPeriodValue = filterObj.filterPeriodValue;
                    this.onlyUndocumented = filterObj.onlyUndocumented;
                    this.onlyUncompleted = filterObj.onlyUncompleted;
                }
                this.setFilter();
            };
            MedikamenteDistributionController.prototype.initForm = function () {
                this.reference = QMC.Common.Constants.GUID_EMPTY;
                this.noReasonError = false;
                this.date = new Date();
                this.time = new Date();
                this.form = {
                    amount: 0,
                    date: new Date(),
                    isDistributed: true,
                    referenceTimeId: QMC.Common.Constants.GUID_EMPTY,
                    reason: ""
                };
            };
            MedikamenteDistributionController.prototype.events = function () {
                var _this = this;
                var filterChange = function (oldVal, newVal) {
                    if (oldVal !== newVal) {
                        _this.setFilter();
                        _this.getMedications();
                    }
                };
                this.$scope.$watch('vm.onlyUndocumented', filterChange, true);
                this.$scope.$watch('vm.onlyUncompleted', filterChange, true);
                this.$scope.$watch('vm.filterPeriodValue', filterChange, true);
                this.validation = {
                    errors: ["Es wurde noch keine Validierung durchgeführt"],
                    warnings: []
                };
                this.$scope.$watch('vm.form.isDistributed', function (newVal, oldVal) {
                    if (oldVal !== newVal) {
                        if (newVal === false) {
                            _this.form.amount = 0;
                        }
                    }
                }, true);
                this.$scope.$watch('vm.time', function (newVal, oldVal) {
                    if (oldVal !== newVal) {
                        _this.form.date = _this.$qui.addTimeToDate(_this.date, _this.time);
                    }
                }, true);
                this.$scope.$watch('vm.filter.filterDistributionDateFrom', function (newVal, oldVal) {
                    if (oldVal !== newVal) {
                        _this.getDistributionsForMedication();
                    }
                }, true);
                this.$scope.$watch('vm.filter.filterDistributionDateTo', function (newVal, oldVal) {
                    if (oldVal !== newVal) {
                        _this.getDistributionsForMedication();
                    }
                }, true);
                this.$scope.$watch('vm.date', function (newVal, oldVal) {
                    if (oldVal !== newVal) {
                        _this.form.date = _this.$qui.addTimeToDate(_this.date, _this.time);
                    }
                }, true);
                this.$scope.$watch('vm.form', function (newVal, oldVal) {
                    if (oldVal !== newVal) {
                        _this.validate();
                    }
                }, true);
                this.$scope.$watch('vm.selectedTimepoint', function (newVal, oldVal) {
                    if (oldVal !== newVal && _this.multiEnabled) {
                        for (var _i = 0, _a = _this.currentTimepoints; _i < _a.length; _i++) {
                            var item = _a[_i];
                            item.isChecked = false;
                        }
                        _this.createCurrentTimepoints();
                    }
                }, true);
            };
            MedikamenteDistributionController.prototype.createCurrentTimepoints = function () {
                var _this = this;
                // kill multi validation watcher
                for (var _i = 0, _a = this.multiValidationWatcher; _i < _a.length; _i++) {
                    var item = _a[_i];
                    item();
                }
                // create multi validation watcher
                this.multiValidationWatcher = [];
                this.currentTimepoints = this.timepoints[this.selectedTimepoint];
                if (!this.currentTimepoints || !this.selectedTimepoint)
                    return;
                var _loop_1 = function (i) {
                    this_1.multiValidationWatcher.push(this_1.$scope.$watch("vm.currentTimepoints[" + i + "].form", function (newVal, oldVal) {
                        if (!newVal || newVal === oldVal)
                            return;
                        _this.currentTimepoints[i].validation = _this.validatePlannedMedication(_this.currentTimepoints[i].form);
                    }, true));
                };
                var this_1 = this;
                for (var i = 0; i < this.currentTimepoints.length; i++) {
                    _loop_1(i);
                }
            };
            MedikamenteDistributionController.prototype.setFilter = function () {
                this.filter = {
                    filterDateFrom: this.checkPeriod(this.filterPeriodValue),
                    filterDateTo: new Date(),
                    filterDistributionDateFrom: this.checkPeriod(this.filterPeriodValue),
                    filterDistributionDateTo: new Date(),
                    filterMedicationId: QMC.Common.Constants.GUID_EMPTY,
                    filterMedicationDateFrom: new Date(),
                    filterMedicationDateTo: new Date(),
                };
                var storageOb = {
                    filterPeriodValue: this.filterPeriodValue,
                    onlyUndocumented: this.onlyUndocumented,
                    onlyUncompleted: this.onlyUncompleted
                };
                localStorage.setItem(this.filterStorageKey, JSON.stringify(storageOb));
            };
            MedikamenteDistributionController.prototype.checkPeriod = function (filter) {
                var dateFrom;
                switch (filter) {
                    case '1':
                        dateFrom = new Date();
                        break;
                    case '2':
                        dateFrom = moment().startOf('week').toDate();
                        break;
                    case '3':
                        dateFrom = moment().startOf('month').toDate();
                        break;
                    case '4':
                        dateFrom = moment().subtract(30, 'days').toDate();
                        break;
                    default:
                        dateFrom = moment().startOf('week').toDate();
                        break;
                }
                return dateFrom;
            };
            MedikamenteDistributionController.prototype.showDistributionsModal = function (medication) {
                if ((this.filter.filterMedicationId != medication.id) ||
                    (this.filter.filterDistributionDateFrom === this.filter.filterDateFrom && this.filter.filterDistributionDateTo === this.filter.filterDateTo) ||
                    (this.filter.medicationId === null || this.filter.filterDistributionDateFrom === null || this.filter.filterDistributionDateFTo === null)) {
                    this.showDistributions = {
                        objectId: medication.objectId,
                        client: medication.personForename + " " + medication.personName,
                        medicament: medication.medicament,
                        package: medication.medicamentPackage,
                        medicationType: medication.medicationType,
                        amount: medication.amount,
                        amountDistributed: medication.amountDistributed,
                        isDemand: medication.medicationTypeId === QMC.Common.Constants.DEMAND_MEDICATION,
                        distributions: medication.distributions,
                        timepoint: medication.timepoint
                    };
                    this.filter.filterMedicationId = this.isDemand ? medication.id : medication.medicationId;
                    this.filter.filterDistributionDateFrom = this.filter.filterDateFrom;
                    this.filter.filterDistributionDateTo = this.filter.filterDateTo;
                    this.filter.filterMedicationDateFrom = medication.dateFrom;
                    this.filter.filterMedicationDateTo = medication.dateTo;
                }
                else {
                    this.getDistributionsForMedication();
                }
                $('#medicamentDistributionsModal').modal('show');
            };
            MedikamenteDistributionController.prototype.newDistributionModal = function (medication) {
                this.initForm();
                this.showDistributions = {
                    objectId: medication.objectId,
                    client: medication.personForename + " " + medication.personName,
                    medicament: medication.medicament,
                    package: medication.medicamentPackage,
                    medicationType: medication.medicationType,
                    amount: medication.amount,
                    amountDistributed: medication.amountDistributed,
                    isDemand: medication.medicationTypeId === QMC.Common.Constants.DEMAND_MEDICATION,
                    //use the dateFrom to set the start date of the demanded medication, when is a demanded medication user can set the date
                    //also in the past, but not smaller than the medication start date
                    dateFrom: this.$qui.createDateFromString(medication.dateFrom),
                    dateTo: medication.dateTo != null ? this.$qui.createDateFromString(medication.dateTo) : null,
                };
                this.reference = medication.referenceMedication;
                if (this.reference === undefined)
                    this.reference = medication.objectId;
                this.form.amount = medication.amount;
                if (this.$state.current.name === "medicamentPlannedDistribution") {
                    this.form.referenceTimeId = medication.referenceTimeId;
                    this.date = moment(medication.date).toDate();
                    this.time = moment(medication.date).toDate();
                }
                $('#medicamentNewDistributionModal').modal('show');
            };
            MedikamenteDistributionController.prototype.getTimeString = function (input) {
                var date = moment(input).toDate();
                var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
                var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
                return hours + ":" + minutes;
            };
            MedikamenteDistributionController.prototype.createTimepointModal = function () {
                this.lastList = undefined;
                this.selectedTimepoint = undefined;
                this.createMultiTimepoints();
                $('#multi-medication-modal').modal('show');
            };
            MedikamenteDistributionController.prototype.createMultiTimepoints = function () {
                var _this = this;
                if (!this.multiEnabled)
                    return;
                // if nothing has changed dont update the modal
                if (this.lastList === JSON.stringify(this.ui.plannedMedicationTable.data))
                    return;
                this.lastList = JSON.stringify(this.ui.plannedMedicationTable.data);
                this.timepoints = {};
                this.timepointsMap = [];
                this.currentTimepoints = [];
                this.multiState = "select";
                for (var _i = 0, _a = this.plannedDistributions; _i < _a.length; _i++) {
                    var item = _a[_i];
                    if (item.isDistributed)
                        continue;
                    var timepointName = moment(item.date).format('DD.MM.YYYY') + ' ' + item.timepoint;
                    if (!this.timepoints[timepointName])
                        this.timepoints[timepointName] = [];
                    item.form = {
                        amount: item.amount,
                        date: moment(item.date).toDate(),
                        time: moment(item.date).toDate(),
                        isDistributed: true,
                        reason: '',
                        referenceTimeId: item.referenceTimeId
                    };
                    item.validation = { errors: [], warnings: [] };
                    this.timepoints[timepointName].push(item);
                }
                for (var item in this.timepoints) {
                    this.timepointsMap.push({ text: item, value: item, date: this.$qui.createDateFromString(this.timepoints[item][0].date) });
                }
                this.timepointsMap.sort(function (a, b) { return a.date.getTime() - b.date.getTime(); });
                if (!this.selectedTimepoint || !this.timepointsMap.some(function (x) { return x.value === _this.selectedTimepoint; })) {
                    // preselect timepoint nearest to now
                    var now = new Date().getTime();
                    var minDist = void 0;
                    for (var _b = 0, _c = this.timepointsMap; _b < _c.length; _b++) {
                        var item = _c[_b];
                        var dist = now - item.date.getTime();
                        if (!minDist || minDist > dist) {
                            this.selectedTimepoint = item.value;
                            minDist = dist;
                        }
                    }
                }
                this.createCurrentTimepoints();
                this.$qui.scopeApply();
            };
            MedikamenteDistributionController.prototype.isMultiValid = function () {
                if (!this.selectedTimepoint || !this.currentTimepoints || this.currentTimepoints.length === 0)
                    return false;
                var activeMedications = this.currentTimepoints.filter(function (x) { return x.isChecked; });
                if (activeMedications.length === 0 || activeMedications.filter(function (x) { return x.validation.errors.length > 0; }).length > 0)
                    return false;
                return true;
            };
            MedikamenteDistributionController.prototype.getMultiMedicationHeaderString = function () {
                return this.$qui.formatString(this.lng.translate(21009062, 'Folgende Medikamente werden für den Zeitpunkt <strong>{0}</strong> ausgegeben.'), this.selectedTimepoint);
            };
            MedikamenteDistributionController.prototype.multiToggle = function (state) {
                for (var _i = 0, _a = this.currentTimepoints; _i < _a.length; _i++) {
                    var item = _a[_i];
                    item.isChecked = state;
                }
            };
            ////////////////////////// SERVICECALLS //////////////////////////
            MedikamenteDistributionController.prototype.getMedications = function () {
                if (this.isDemand)
                    this.getDemandMedications();
                if (!this.isDemand)
                    this.getPlannedMedications();
            };
            MedikamenteDistributionController.prototype.getPlannedMedications = function () {
                var _this = this;
                this.loadingPlanned = true;
                this.medicamentService.getPlannedMedicationLists(this.filter.filterDateFrom, this.filter.filterDateTo, this.onlyUncompleted, this.onlyUndocumented).then(function (data) {
                    var _loop_2 = function (item) {
                        item.distAmount = _this.$qui.qmcRounding(item.amountDistributed) + '/' + _this.$qui.qmcRounding(item.amount);
                        item.timepointMobile = moment(item.date).format('DD.MM.YYYY') + " " + item.timepoint;
                        item.isSelected = _this.selectedLines.some(function (x) { return x === item.objectId; });
                    };
                    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                        var item = data_1[_i];
                        _loop_2(item);
                    }
                    _this.plannedDistributions = data;
                    _this.plannedDistributions.map(function (item) { item.client = _this.createClientDisplayTitle(item); });
                    _this.ui.plannedMedicationTable.data = _this.plannedDistributions;
                    _this.$qui.functionWaiter("createPlannedTable", _this);
                    _this.createMultiTimepoints();
                    _this.loadingPlanned = false;
                    _this.selectedLines = _this.selectedLines.filter(function (x) { return data.some(function (y) { return x === y.objectId; }); });
                });
            };
            MedikamenteDistributionController.prototype.createClientDisplayTitle = function (item) {
                var _a, _b;
                var persNrShortDescr = (((_a = item.personNr) !== null && _a !== void 0 ? _a : '') + '/' + ((_b = item.personShortCaption) !== null && _b !== void 0 ? _b : '')).replace(/^\/|\/$/g, '');
                return item.personForename + " " + item.personName + (persNrShortDescr ? " (" + persNrShortDescr + ")" : '');
            };
            MedikamenteDistributionController.prototype.getDemandMedications = function () {
                var _this = this;
                this.loadingDemand = true;
                this.medicamentService.getDemandMedicationLists(this.filter.filterDateFrom, this.filter.filterDateTo, this.onlyUncompleted, this.onlyUndocumented).then(function (data) {
                    _this.demandDistributions = data;
                    _this.demandDistributions.map(function (item) {
                        item.client = _this.$qui.createPersonDisplay(item.personName, item.personForename, item.personShortCaption, item.personNr);
                    });
                    _this.demandDistributions.map(function (obj, index) {
                        obj.maxAmountString = obj.maxAmount + ' ' + obj.maxAmountInterval;
                        obj.lastDistributionDateString = obj.lastDistribution && moment(obj.lastDistribution).toDate() >= new Date(1900, 1, 1) ? moment(obj.lastDistribution).format('DD.MM.YYYY') : "";
                    });
                    _this.ui.demandMedicationTable.data = _this.demandDistributions;
                    _this.$qui.functionWaiter("createDemandTable", _this);
                    _this.loadingDemand = false;
                });
            };
            MedikamenteDistributionController.prototype.getDistributionsForMedication = function () {
                var _this = this;
                var _a, _b, _c;
                var dateFrom = (_a = this.filter.filterDistributionDateFrom) !== null && _a !== void 0 ? _a : this.filter.filterMedicationDateFrom;
                var dateTo = (_b = this.filter.filterDistributionDateTo) !== null && _b !== void 0 ? _b : this.filter.filterMedicationDateTo;
                if (!((_c = this.filter) === null || _c === void 0 ? void 0 : _c.filterMedicationId))
                    return;
                this.medicamentService.getDistributionsForMedication(moment(dateFrom).startOf('day').format(), moment(dateTo).endOf('day').format(), this.filter.filterMedicationId).then(function (data) {
                    if (_this.showDistributions)
                        _this.showDistributions.distributions = data;
                });
            };
            MedikamenteDistributionController.prototype.addMedicamentDistribution = function () {
                var _this = this;
                this.form.date = this.$qui.addTimeToDate(this.date, this.time);
                if (this.form.reason === "" && !this.form.isDistributed) {
                    this.noReasonError = true;
                }
                else {
                    $('#medicamentNewDistributionModal').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    if (this.$scope.form.$valid) {
                        this.medicamentService.postMedication(this.reference, this.form).then(function (data) {
                            _this.clearTable();
                            _this.$qui.notify(_this.$qui.successNote, _this.lng.translate(20000291, 'Der Eintrag wurde gespeichert.'));
                            _this.getMedications();
                        });
                    }
                }
            };
            MedikamenteDistributionController.prototype.saveMulti = function () {
                var _this = this;
                if (!this.multiEnabled)
                    return;
                this.multiState = 'loading';
                var medications = [];
                for (var _i = 0, _a = this.currentTimepoints; _i < _a.length; _i++) {
                    var item = _a[_i];
                    if (item.isChecked && item.validation.errors.length === 0) {
                        medications.push({
                            amount: item.form.amount,
                            date: this.$qui.addTimeToDate(item.form.date, item.form.time),
                            isDistributed: item.form.isDistributed,
                            reason: item.form.reason,
                            referenceTimeId: item.referenceTimeId,
                            medicationId: item.referenceMedication
                        });
                    }
                }
                this.medicamentService.postMedications(medications).then(function () {
                    _this.$qui.notify(_this.$qui.successNote, _this.lng.translate(20000291, 'Der Eintrag wurde gespeichert.'));
                }).finally(function () {
                    _this.clearTable();
                    $('#multi-medication-modal').modal('hide');
                    _this.multiState = 'select';
                    _this.getMedications();
                });
            };
            MedikamenteDistributionController.prototype.clearTable = function () {
                this.ui.plannedMedicationTable.data = [];
                this.createPlannedTable();
            };
            MedikamenteDistributionController.prototype.validate = function () {
                var _this = this;
                if (this.isDemand && this.form.amount >= 0) {
                    if (!this.form || !this.showDistributions)
                        return;
                    if (!this.form.isDistributed) {
                        this.lastValidation = null;
                        this.validation = {
                            errors: [],
                            warnings: []
                        };
                    }
                    var validationRequest_1 = {
                        medicationId: this.showDistributions.objectId,
                        amount: this.form.amount,
                        date: this.form.date
                    };
                    if (this.lastValidation && JSON.stringify(this.lastValidation) === JSON.stringify(validationRequest_1))
                        return;
                    this.lastValidation = validationRequest_1;
                    this.loadValidation = true;
                    setTimeout(function () {
                        if (_this.lastValidation && JSON.stringify(_this.lastValidation) === JSON.stringify(validationRequest_1)) {
                            _this.medicamentService.postValidation(validationRequest_1).then(function (data) {
                                _this.validation = data;
                                _this.loadValidation = false;
                            }).catch(function () {
                                _this.validation = {
                                    errors: ["Während der Validierung trat ein Fehler auf."],
                                    warnings: []
                                };
                                _this.loadValidation = false;
                            });
                        }
                    }, 500);
                }
                else {
                    this.validation = this.validatePlannedMedication(this.form);
                }
            };
            MedikamenteDistributionController.prototype.validatePlannedMedication = function (medicationForm) {
                var validation = { errors: [], warnings: [] };
                if (medicationForm.amount > 0) {
                    if (!medicationForm || !this.ui.plannedMedicationTable.data)
                        return validation;
                    var amount = medicationForm.amount;
                    var planning = this.ui.plannedMedicationTable.data.find(function (x) { return x.objectId === medicationForm.referenceTimeId; });
                    if (planning) {
                        amount = parseFloat(amount + '') + parseFloat(planning.amountDistributed);
                    }
                    if (amount !== planning.amount) {
                        if (!medicationForm.reason || medicationForm.reason.length < 1) {
                            validation.errors.push(this.lng.translate(21009058, "Die Ausgabemenge ist abweichend. Bitte geben Sie einen Grund an."));
                        }
                        else {
                            validation.warnings.push(this.lng.translate(21009059, "Die Ausgabemenge ist abweichend."));
                        }
                    }
                }
                else if (medicationForm.isDistributed) {
                    validation.errors.push(this.lng.translate(21009063, "Bitte geben Sie eine Menge an."));
                }
                return validation;
            };
            MedikamenteDistributionController.prototype.selectLine = function (status, line) {
                if (status)
                    this.selectedLines.push(line.objectId);
                else
                    this.selectedLines = this.selectedLines.filter(function (x) { return x !== line.objectId; });
            };
            MedikamenteDistributionController.prototype.distributeSelectedLines = function () {
                var _this = this;
                if (!this.selectedLines.length)
                    return;
                this.loadingPlanned = true;
                this.recentlyDistributedPannedMedications = [];
                this.selectedLines.forEach(function (line) {
                    var planning = _this.plannedDistributions.find(function (x) { return x.objectId === line; });
                    if (!planning || planning.isDistributed || planning.isDocumented)
                        return;
                    _this.recentlyDistributedPannedMedications.push({
                        amount: planning.amount,
                        date: planning.date,
                        isDistributed: true,
                        reason: '',
                        referenceTimeId: planning.referenceTimeId,
                        medicationId: planning.referenceMedication,
                        timepoint: planning.timepoint,
                        client: _this.createClientDisplayTitle(planning),
                        medicament: planning.medicament
                    });
                });
                this.medicamentService.postMedications(this.recentlyDistributedPannedMedications).then(function () {
                    _this.$qui.notify(_this.$qui.successNote, _this.selectedLines.length + ' ' + _this.lng.translate(21009066, 'Medikationen ausgegeben.'));
                    _this.selectedLines = [];
                    $('#recently-distributed-medications-modal').modal('show');
                }).finally(function () {
                    _this.clearTable();
                    _this.getMedications();
                });
            };
            MedikamenteDistributionController = __decorate([
                QMC.Controller('QMC.Medikamente', 'MedikamenteDistributionController'),
                QMC.Inject('$location', 'MedikamenteService', '$qui', '$stateParams', '$state', '$scope', 'QmcLanguageService', 'KlientService', 'QmcPermissionService', 'UserService')
            ], MedikamenteDistributionController);
            return MedikamenteDistributionController;
        }());
    })(Medikamente = QMC.Medikamente || (QMC.Medikamente = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Medikamente;
    (function (Medikamente) {
        /**
         * Stammdaten UserInterface class
         *
         * @export
         * @class UserInterface
         * @extends {Common.UserInterface}
         */
        var UserInterface = /** @class */ (function (_super) {
            __extends(UserInterface, _super);
            function UserInterface() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                /**
                 * Medicament table
                 * @memberOf UserInterface
                 */
                _this.medicamentTable = {
                    "config": {
                        "defaultSort": "title",
                        "sortReverse": "false",
                    },
                    "table": {
                        "Name": {
                            "label": "title",
                            "dType": "string",
                            "lngTag": "20000072"
                        },
                        "Darreichung": {
                            "label": "presentation",
                            "dType": "string",
                            "lngTag": "21009002"
                        },
                        "Kategorie": {
                            "label": "category",
                            "dType": "string",
                            "lngTag": "20000137"
                        },
                        "Wirkstoff": {
                            "label": "activeComponent",
                            "dType": "string",
                            "lngTag": "21009004"
                        },
                        "Verschreibungspflichtig": {
                            "label": "isPrescriptionNeeded",
                            "dType": "Bool",
                            "lngTag": "21009005"
                        },
                        "Apothekenpflichtig": {
                            "label": "isPharmacyOnly",
                            "dType": "Bool",
                            "lngTag": "21009006"
                        },
                        "Aktionen": {
                            "dType": "Button",
                            "icon": "qm-icon-pencil blue",
                            "href": "#/medicament/{{objectId}}",
                            "tooltip": "Bearbeiten",
                            "lngTag": "20000044",
                            "permission": "modify"
                        },
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-pill",
                        },
                        "text": {
                            "label": "title",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "presentation",
                                "dType": "string"
                            },
                            {
                                "label": "activeComponent",
                                "dType": "string",
                            },
                        ],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "href": "#/medicament/{{objectId}}",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Medikament bearbeiten",
                                "lngTag": "21009007",
                                "permission": "view",
                            }]
                    },
                    "data": null,
                };
                _this.medicamentForm = {
                    form: [
                        {
                            placeholder: "Name",
                            label: "Name",
                            type: "String",
                            lngTag: "20000072",
                            required: "true",
                            model: "title",
                            validate: {
                                message: "Bitte einen Namen eingeben.",
                                messageTag: "20000079",
                            },
                            style: {
                                icon: "qm-icon-check",
                                class: "col-xs-12"
                            },
                        },
                        {
                            placeholder: "Darreichungsform auswählen...",
                            label: "Darreichungsform",
                            type: "Select",
                            lngTag: "21009009",
                            model: "presentationId",
                            required: "true",
                            dataSource: "getPresentationWvList",
                            validate: {
                                message: "Bitte Darreichungsform eintragen."
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        },
                        {
                            placeholder: "Kategorie auswählen...",
                            label: "Kategorie",
                            type: "Select",
                            lngTag: "20000137",
                            model: "categoryId",
                            dataSource: "getCategoryList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                        },
                        {
                            placeholder: "Hersteller auswählen...",
                            label: "Hersteller",
                            type: "Select",
                            lngTag: "21009011",
                            model: "producerId",
                            dataSource: "getProducerWvList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                        },
                        {
                            placeholder: "Hauptwirkstoff",
                            label: "Hauptwirkstoff",
                            type: "String",
                            lngTag: "21009012",
                            model: "activeComponent",
                            style: {
                                icon: "qm-icon-injection",
                                class: "col-xs-12 col-md-6"
                            }
                        },
                        {
                            label: "Zusatz",
                            type: "String",
                            model: "comment",
                            lngTag: "21009016",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12",
                            }
                        },
                        {
                            label: "Apothekenpflichtig",
                            type: "Checkbox",
                            lngTag: "21009006",
                            model: "isPharmacyOnly",
                            id: "modPharmacy",
                            style: {
                                class: "col-xs-6"
                            }
                        },
                        {
                            label: "Verschreibungspflichtig",
                            type: "Checkbox",
                            lngTag: "21009005",
                            model: "isPrescriptionNeeded",
                            id: "modPrescrip",
                            style: {
                                class: "col-xs-6"
                            }
                        },
                        {
                            label: "Zugangsbeschränkt",
                            type: "Checkbox",
                            lngTag: "21009013",
                            model: "isRestricted",
                            id: "modRestrict",
                            style: {
                                class: "col-xs-6"
                            }
                        },
                        {
                            label: "Betäubungsmittel",
                            type: "Checkbox",
                            lngTag: "21009014",
                            model: "isAnesthetic",
                            id: "modAnesthetic",
                            style: {
                                class: "col-xs-6"
                            }
                        }
                    ],
                    actions: {
                        post: "addMedicament"
                    }
                };
                _this.mediPackagesTable = {
                    "config": {
                        "showTitle": "true",
                        "defaultSort": "displayTitle",
                        "sortReverse": "false",
                    },
                    "table": {
                        "Menge": {
                            "label": "packageAmount",
                            "dType": "Number",
                            "lngTag": "20000095"
                        },
                        "Einheit": {
                            "label": "packageUnit",
                            "dType": "string",
                            "lngTag": "20000096"
                        },
                        "Normgröße": {
                            "label": "standardsize",
                            "dType": "string",
                            "lngTag": "20000097"
                        },
                        "Gültigkeit": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000098"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editPackage",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "openModal": "true",
                                "targetModal": "#medicamentPackageModal",
                                "lngTag": "20000044",
                                "permission": "pmodify"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-pill"
                        },
                        "text": {
                            "label": "displayTitle",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": ["packageAmount", "packageUnit"],
                                "dType": "string"
                            },
                        ],
                        "buttons": {
                            "icon": "qm-icon-pencil blue",
                            "click": "editPackage",
                            "label": "data",
                            "dType": "Button",
                            "tooltip": "Bearbeiten",
                            "openModal": "true",
                            "targetModal": "#medicamentPackageModal",
                            "lngTag": "20000044",
                        }
                    },
                    "data": null,
                };
                _this.mediPackagesForm = {
                    form: [
                        {
                            lngTag: {
                                dateFrom: "20000277",
                                dateTo: "20000278"
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        },
                        {
                            label: "Menge",
                            type: "Number",
                            lngTag: "20000095",
                            model: "packageAmount",
                            maxLength: 10,
                            style: {
                                icon: "qm-icon-symbol_hash",
                                class: "col-md-3 col-xs-6 no-mobile-padding-left",
                            }
                        },
                        {
                            placeholder: "Darreichungsform auswählen ...",
                            label: "Darreichungsform",
                            type: "Select",
                            lngTag: "21009009",
                            model: "packageUnitId",
                            required: true,
                            dataSource: "getPackageTypeList",
                            validate: {
                                message: "Bitte auswählen",
                                messageTag: "20000099",
                            },
                            style: {
                                class: "col-md-9 col-xs-6 no-mobile-padding-right"
                            },
                        },
                        {
                            label: "Normgröße",
                            type: "Select",
                            lngTag: "20000097",
                            model: "standardSizeId",
                            dataSource: "getStandardSizeWvList",
                            style: {
                                class: "col-xs-12"
                            },
                        },
                        {
                            placeholder: "PZN",
                            placeholderTag: "20000092",
                            label: "PZN",
                            type: "String",
                            lngTag: "20000092",
                            model: "pzn",
                            style: {
                                icon: "fa fa-barcode",
                                class: "col-md-6 col-xs-12"
                            },
                        },
                        {
                            placeholder: "EAN",
                            placeholderTag: "20000093",
                            label: "EAN",
                            type: "String",
                            lngTag: "20000093",
                            model: "ean",
                            style: {
                                icon: "fa fa-barcode",
                                class: "col-md-6 col-xs-12"
                            },
                        },
                        {
                            placeholder: "Wirkstoffmenge",
                            placeholderTag: "21009056",
                            label: "Wirkstoffmenge",
                            type: "Number",
                            lngTag: "21009056",
                            model: "activeComponentAmount",
                            maxLength: 10,
                            style: {
                                icon: "qm-icon-symbol_hash",
                                class: "col-md-9 col-xs-6 no-mobile-padding-left"
                            }
                        },
                        {
                            label: "Einheit",
                            type: "Select",
                            model: "activeComponentUnitId",
                            dataSource: "getActiveComponentUnitWvList",
                            lngTag: "20000096",
                            style: {
                                class: "col-md-3 col-xs-6 no-mobile-padding-right"
                            },
                        },
                        {
                            placeholder: "Bemerkung",
                            placeholderTag: "20000049",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: 255,
                            lngTag: "20000049",
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12",
                            }
                        }
                    ],
                    actions: {
                        post: "postMedicamentPackage",
                        put: "putMedicamentPackage",
                        delete: "deleteMedicamentPackage"
                    }
                };
                _this.plannedMedicationTable = {
                    "config": {
                        "defaultSort": "date",
                        "sortReverse": "false",
                    },
                    "table": {
                        "": {
                            "id": "objectId",
                            "selected": "isSelected",
                            "dType": "Checkbox",
                            "events": {
                                "onChange": "selectLine"
                            },
                            "hide": "isDocumented"
                        },
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045"
                        },
                        "Zeitpunkt": {
                            "label": "timepoint",
                            "dType": "string",
                            "lngTag": "21009027"
                        },
                        "Medikament": {
                            "label": "medicament",
                            "dType": "string",
                            "lngTag": "21009028"
                        },
                        "Klient": {
                            "label": "client",
                            "dType": "string",
                            "lngTag": "21002000"
                        },
                        "Menge": {
                            "label": "distAmount",
                            "dType": "string",
                            "lngTag": "20000095"
                        },
                        "Ausgabe dokumentiert": {
                            "label": "isDocumented",
                            "dType": "Bool",
                            "lngTag": "21009039"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-eye blue",
                                "click": "showDistributionsModal",
                                "tooltip": "Ausgaben betrachten",
                                "lngTag": "21009040",
                                "dType": "Button",
                                "targetModal": "#medicamentDistributionsModal",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-pill green",
                                "click": "newDistributionModal",
                                "tooltip": "Medikament ausgeben",
                                "lngTag": "21009041",
                                "dType": "Button",
                                "events": {
                                    "hide": "isDistributed"
                                },
                                "targetModal": "#medicamentNewDistributionModal",
                                "permission": "new"
                            }],
                    }
                    // Mobile Card View
                    ,
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-pill"
                        },
                        "text": {
                            "label": "medicament",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "client",
                                "dType": "string"
                            },
                            {
                                "label": "timepointMobile",
                                "dType": "string",
                            },
                            {
                                "label": "isDocumented",
                                "text": "Ist ausgegeben",
                                "lngTag": "21009033",
                                "dType": "Bool",
                            },
                            {
                                "label": "isDocumented",
                                "text": "Ausgabe dokumentiert",
                                "lngTag": "21009039",
                                "dType": "Bool",
                            },
                        ],
                        "buttons": [
                            {
                                "icon": "qm-icon-eye blue",
                                "click": "showDistributionsModal",
                                "tooltip": "Ausgaben betrachten",
                                "lngTag": "21009040",
                                "dType": "Button",
                                "targetModal": "#medicamentDistributionsModal",
                                "permission": "modify"
                            },
                            {
                                "icon": "qm-icon-pill green",
                                "click": "newDistributionModal",
                                "tooltip": "Medikament ausgeben",
                                "lngTag": "21009041",
                                "dType": "Button",
                                "hide": "isDistributed",
                                "targetModal": "#medicamentNewDistributionModal",
                                "permission": "new",
                                "events": {
                                    "hide": "isDistributed"
                                },
                            }
                        ]
                    },
                    "data": null,
                };
                _this.demandMedicationTable = {
                    "table": {
                        "Medikament": {
                            "label": "medicament",
                            "dType": "string",
                            "lngTag": "21009028"
                        },
                        "Klient": {
                            "label": "client",
                            "dType": "string",
                            "lngTag": "21002000"
                        },
                        "Letzte Ausgabe": {
                            "label": "lastDistributionDateString",
                            "dType": "Date",
                            "lngTag": "21009044"
                        },
                        "Packung": {
                            "label": "medicamentPackage",
                            "dType": "string",
                            "lngTag": "21009029"
                        },
                        "Max. Menge": {
                            "label": "maxAmountString",
                            "dType": "string",
                            "lngTag": "21009045"
                        },
                        "Aktionen": [
                            {
                                "icon": "qm-icon-eye blue",
                                "click": "showDistributionsModal",
                                "tooltip": "Ausgaben betrachten",
                                "lngTag": "21009040",
                                "dType": "Button",
                                "targetModal": "#medicamentDistributionsModal",
                                "permission": "modify"
                            },
                            {
                                "icon": "qm-icon-pill green",
                                "click": "newDistributionModal",
                                "tooltip": "Medikament ausgeben",
                                "lngTag": "21009041",
                                "dType": "Button",
                                "events": {
                                    "hide": "isDistributed"
                                },
                                "targetModal": "#medicamentNewDistributionModal",
                                "permission": "new"
                            }
                        ],
                    }
                    // Mobile Card View
                    ,
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-pill"
                        },
                        "text": {
                            "label": "medicament",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "medicamentPackage",
                                "dType": "string"
                            },
                            {
                                "label": "client",
                                "dType": "string"
                            },
                        ],
                        "buttons": [
                            {
                                "icon": "qm-icon-eye blue",
                                "click": "showDistributionsModal",
                                "tooltip": "Ausgaben betrachten",
                                "lngTag": "21009040",
                                "dType": "Button",
                                "targetModal": "#medicamentDistributionsModal",
                                "permission": "modify"
                            },
                            {
                                "icon": "qm-icon-pill green",
                                "click": "newDistributionModal",
                                "tooltip": "Medikament ausgeben",
                                "lngTag": "21009041",
                                "dType": "Button",
                                "hide": "isDistributed",
                                "targetModal": "#medicamentNewDistributionModal",
                                "permission": "new"
                            }
                        ]
                    },
                    "data": null,
                };
                return _this;
            }
            return UserInterface;
        }(QMC.Common.UserInterface));
        Medikamente.UserInterface = UserInterface;
    })(Medikamente = QMC.Medikamente || (QMC.Medikamente = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Medikamente/qmc.medikamente.js.map
